module.exports = __webpack_public_path__ + "img/CC-BY-NC-ND.9772d34b.png";